import * as React from 'react';
import BasePaycodeListLayout from './BasePaycodeListLayout';
import ConfirmPaycodePopup from '../containers/codes/ConfirmPaycodePopup';


export default (params) => {
  const { paycodeId } = params;

  return BasePaycodeListLayout(
    <ConfirmPaycodePopup
      paycodeId={paycodeId}
      title="Code Information"
    />
  );
};
